import { render, staticRenderFns } from "./PDFList.vue?vue&type=template&id=2c7a0548&scoped=true"
import script from "./PDFList.vue?vue&type=script&lang=js"
export * from "./PDFList.vue?vue&type=script&lang=js"
import style0 from "./PDFList.vue?vue&type=style&index=0&id=2c7a0548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a0548",
  null
  
)

export default component.exports